import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import {
    ContentGetItemResponse,
    ParamsGetWarehouse,
} from "../../constants/types";
import { useDetailBarangModal } from "../../context/detailBarangModalContext";
import { useTransaksi } from "../../context/transaksiContext";
import toRupiah from "../../utils/toRupiah";
import StarIcon from "@mui/icons-material/Star";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import toRibuan from "../../utils/toRibuan";
import useUser from "../../services/queries/useUser";
import useWarehouse from "../../services/queries/useWarehouse";
import { getLocalWarehouseId } from "../../utils/handleChangeWarehouseId";

interface ICardBarangMiniProps {
    data: ContentGetItemResponse;
}

const CardBarangMini = ({ data }: ICardBarangMiniProps) => {
    const {
        id,
        namaBarang,
        kategori,
        harga,
        multipleGambar,
        sku,
        stok: jumlahStok,
        stokPusat,
        detailBundling,
        favorite,
        hpp,
        hargaMultiple,
    } = data;
    const { addToCart, cart } = useTransaksi();
    const { openModalDetailBarang } = useDetailBarangModal();

    const { data: user } = useUser();

    const initialParamsWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };

    const [paramsWarehouse, setParamsWarehouse] =
        React.useState<ParamsGetWarehouse>(initialParamsWarehouse);
    const { data: warehouse } = useWarehouse(paramsWarehouse);

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user]);

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return warehouse?.content.find((li) => li.id === warehouseId);
        }
        return warehouse?.content[0];
    }, [warehouseId, warehouse]);

    React.useEffect(() => {
        if (user && user?.warehouseId?.length > 0) {
            setParamsWarehouse((prev) => ({
                ...prev,
                userId: user.warehouseId[0],
            }));
        }
    }, [user]);

    return (
        <Box
            onClick={() => openModalDetailBarang(data)}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: 1,
                marginBottom: 1,
                padding: 1,
                gap: 1,
            }}
        >
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body2" fontWeight={500}>
                        {namaBarang}
                    </Typography>
                    {favorite > 0 && (
                        <StarIcon
                            sx={{
                                color: "#fbbf24",
                                bgcolor: "#FFFFFF",
                            }}
                            fontSize="small"
                        />
                    )}
                </Stack>
                <Typography
                    variant="caption"
                    color={
                        warehouseData?.isDropship === 1
                            ? (stokPusat < 5 && stokPusat !== null) ||
                              !detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                                ? "#ef4444"
                                : "#76747C"
                            : (jumlahStok < 5 && jumlahStok !== null) ||
                              !detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                            ? "#ef4444"
                            : "#76747C"
                    }
                    fontWeight={
                        warehouseData?.isDropship === 1
                            ? (stokPusat < 5 && stokPusat !== null) ||
                              !detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                                ? 700
                                : 600
                            : (jumlahStok < 5 && jumlahStok !== null) ||
                              !detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                            ? 700
                            : 600
                    }
                >
                    {warehouseData?.isDropship === 1
                        ? detailBundling.length > 0
                            ? detailBundling.every(
                                  (item) => item.stok === null || item.stok > 0,
                              )
                                ? "Otomatis"
                                : "Ada barang yang habis"
                            : stokPusat === null
                            ? "Tanpa stok"
                            : stokPusat > 5
                            ? "Tersedia " + toRibuan(stokPusat) + " barang"
                            : stokPusat <= 5 && stokPusat > 0
                            ? "Barang tersisa " + toRibuan(stokPusat)
                            : "Barang telah habis"
                        : detailBundling.length > 0
                        ? detailBundling.every(
                              (item) => item.stok === null || item.stok > 0,
                          )
                            ? "Otomatis"
                            : "Ada barang yang habis"
                        : jumlahStok === null
                        ? "Tanpa stok"
                        : jumlahStok > 5
                        ? "Tersedia " + toRibuan(jumlahStok) + " barang"
                        : jumlahStok <= 5 && jumlahStok > 0
                        ? "Barang tersisa " + toRibuan(jumlahStok)
                        : "Barang telah habis"}
                </Typography>
                {hargaMultiple.length > 0 ? (
                    <Typography
                        variant="caption"
                        color="#76747C"
                        fontWeight="bold"
                    >
                        {toRupiah(Number(hargaMultiple[0].harga))}
                    </Typography>
                ) : (
                    <Typography
                        variant="caption"
                        color="#76747C"
                        fontWeight="bold"
                    >
                        {toRupiah(harga)}
                    </Typography>
                )}
            </Stack>
            <Button
                disabled={
                    warehouseData?.isDropship === 1
                        ? cart.findIndex((c) => c.id === id) >= 0 ||
                          stokPusat === null ||
                          (stokPusat <= 0 && stokPusat !== null) ||
                          !detailBundling.every(
                              (item) => item.stok === null || item.stok > 0,
                          )
                        : cart.findIndex((c) => c.id === id) >= 0 ||
                          jumlahStok === null ||
                          (jumlahStok <= 0 && jumlahStok !== null) ||
                          !detailBundling.every(
                              (item) => item.stok === null || item.stok > 0,
                          )
                }
                variant="contained"
                onClick={(event) => {
                    event.stopPropagation();
                    addToCart({
                        id,
                        namaBarang,
                        namaKategori: kategori.nama,
                        harga:
                            hargaMultiple.length > 0
                                ? Number(hargaMultiple[0].harga)
                                : harga,
                        url: multipleGambar[0].gambar,
                        qty: 1,
                        sku,
                        jumlahStok,
                        stokPusat,
                        detailBundling,
                        hpp,
                        faktur: [],
                        multipleHarga: hargaMultiple.map((li) => ({
                            id: li.id,
                            harga: Number(li.harga),
                            keterangan: li.keterangan,
                        })),
                    });
                }}
                startIcon={
                    cart.findIndex((c) => c.id === id) >= 0 ? (
                        <ShoppingCartIcon />
                    ) : (
                        <AddShoppingCartIcon />
                    )
                }
                size="small"
                sx={{ minWidth: "150px", maxWidth: "150px" }}
            >
                {warehouseData?.isDropship === 1
                    ? cart.findIndex((c) => c.id === id) >= 0
                        ? "Di Keranjang"
                        : (stokPusat <= 0 && stokPusat !== null) ||
                          !detailBundling.every(
                              (item) => item.stok === null || item.stok > 0,
                          )
                        ? "Stok Habis"
                        : "Pesan"
                    : cart.findIndex((c) => c.id === id) >= 0
                    ? "Di Keranjang"
                    : (jumlahStok <= 0 && jumlahStok !== null) ||
                      !detailBundling.every(
                          (item) => item.stok === null || item.stok > 0,
                      )
                    ? "Stok Habis"
                    : "Pesan"}
            </Button>
        </Box>
    );
};

export default CardBarangMini;
